import { ApiRequest } from '../baseService'

const BASE = 'app/xero/connections'

export enum XeroConnectionStatus {
  NotConnected = 0,
  Connected = 1,
  NeedsReauth = 2,
  Inactive = 3,
}

// DTOs matching the backend
export interface XeroConnectionDto {
  id: string
  name: string
  clientId: string
  scope: string
  xeroTenantId: string | null
  expiresAtUtc: string
  isActive: boolean
  isDefault: boolean
  status: XeroConnectionStatus
  tenantId: string | null
  trackingCategory1Name?: string | null
  trackingOption1?: string | null
  trackingCategory2Name?: string | null
  trackingOption2?: string | null
  isTrackingCategoryEnabled: boolean
}

export interface XeroConnectionCreateUpdateDto {
  name: string
  clientId: string
  clientSecret?: string
  scope: string
  webHooksKey?: string
  isActive: boolean
  isDefault: boolean
  trackingCategory1Name?: string | null
  trackingOption1?: string | null
  trackingCategory2Name?: string | null
  trackingOption2?: string | null
  isTrackingCategoryEnabled: boolean
}

export interface XeroTrackingCategoryDto {
  name: string
  options: string[]
}

const GetConnections = () => {
  return ApiRequest.get(`${BASE}`)
}

const GetConnection = (id: string) => {
  return ApiRequest.get(`${BASE}/${id}`)
}

const CreateConnection = (data: XeroConnectionCreateUpdateDto) => {
  return ApiRequest.post(`${BASE}`, data)
}

const UpdateConnection = (id: string, data: XeroConnectionCreateUpdateDto) => {
  return ApiRequest.put(`${BASE}/${id}`, data)
}

const DeleteConnection = (id: string) => {
  return ApiRequest.delete(`${BASE}/${id}`)
}

const GetAuthorizeUrl = (id: string) => {
  return ApiRequest.get(`${BASE}/${id}/authorize`)
}

const GetTrackingCategories = (id: string) => {
  return ApiRequest.get(`${BASE}/${id}/tracking-categories`)
}

const API = {
  GetConnections,
  GetConnection,
  CreateConnection,
  UpdateConnection,
  DeleteConnection,
  GetAuthorizeUrl,
  GetTrackingCategories,
}

export default API
